/**
 * manualConsoleUrls.ts - mapping ControlId -> URL deep-link console Microsoft.
 *
 * Utilise dans la page /manual-checks pour afficher un bouton "Verifier dans
 * la console" qui ouvre directement le bon ecran admin Microsoft.
 *
 * Maintenance : quand on ajoute un nouveau controle manuel au catalogue,
 * ajouter sa cle ici. Si le controle est purement de gouvernance (playbook,
 * formation, processus interne) et n a pas d ecran admin Microsoft, laisser
 * absent du map - le bouton n apparaitra pas.
 *
 * Sources :
 * - Admin Center      : admin.microsoft.com
 * - Defender XDR      : security.microsoft.com
 * - Purview           : purview.microsoft.com
 * - Entra ID          : entra.microsoft.com
 * - Intune            : intune.microsoft.com
 * - Power Platform    : admin.powerplatform.microsoft.com
 * - Defender for Cloud Apps (MCAS) : security.microsoft.com/cloudapps
 */

export const MANUAL_CONSOLE_URLS: Record<string, string> = {
  // -- Power Platform (APP-*) ---------------------------------------------
  'APP-001': 'https://admin.powerplatform.microsoft.com/dlp-policies',
  'APP-002': 'https://admin.powerplatform.microsoft.com/manage/environments',
  'APP-003': 'https://make.powerautomate.com/admin/',

  // -- Collaboration / Teams (COL-*) --------------------------------------
  'COL-002': 'https://admin.teams.microsoft.com/users/externalAccess',
  'COL-003': 'https://admin.teams.microsoft.com/policies/meetings',

  // -- Email / Defender Office 365 (EM-*) ---------------------------------
  'EM-002':  'https://security.microsoft.com/safeattachmentv2',
  'EM-003':  'https://security.microsoft.com/safelinksv2',
  'EM-008':  'https://security.microsoft.com/tenantAllowBlockList',

  // -- Protection des donnees / Purview (DP-*) ----------------------------
  'DP-001':  'https://purview.microsoft.com/datalossprevention/policies',
  'DP-005':  'https://purview.microsoft.com/datalifecyclemanagement/policies',
  'DP-006':  'https://intune.microsoft.com/#view/Microsoft_Intune_DeviceSettings/DisksMenu/~/diskEncryption',
  'DP-013':  'https://admin.microsoft.com/Adminportal/Home#/Settings/SecurityPrivacy',
  'DP-016':  'https://admin.teams.microsoft.com/users/externalAccess',
  'DP-017':  'https://admin.microsoft.com/sharepoint?page=sharing&modern=true',
  'DP-018':  'https://purview.microsoft.com/datalifecyclemanagement/m365backup',
  'DP-019':  'https://purview.microsoft.com/ediscovery/hold',

  // -- Identite & acces avance (ID-*) -------------------------------------
  // ID-031 PAW + ID-032 Tier model : gouvernance interne, pas de console MS dediee
  // -> volontairement absents du map

  // -- Logs & monitoring / MCAS / Sentinel (LG-*) -------------------------
  'LG-004':  'https://security.microsoft.com/cloudapps/settings',
  // LG-005 Playbook incidents : gouvernance, pas de console
  'LG-009':  'https://portal.azure.com/#blade/Microsoft_Azure_Security_Insights/MainMenuBlade/0',
  'LG-011':  'https://security.microsoft.com/v2/advanced-hunting',
  'LG-013':  'https://entra.microsoft.com/#view/Microsoft_AAD_IAM/IdentityProtectionMenuBlade/~/RiskySignIns',
  'LG-015':  'https://security.microsoft.com/cloudapps/app-connectors',
  'LG-016':  'https://security.microsoft.com/cloudapps/discovery',
  'LG-017':  'https://security.microsoft.com/cloudapps/oauth',
  'LG-018':  'https://security.microsoft.com/cloudapps/file-policies',
  'LG-019':  'https://security.microsoft.com/cloudapps/policy/policy-templates?policyType=anomaly-detection',
};

export function getManualConsoleUrl(controlId: string): string | undefined {
  return MANUAL_CONSOLE_URLS[controlId];
}
